<script setup lang="ts">
import Twig from 'twig'
import { parseMarkdown } from '@comark/nuxt/parse'
import breaks from '@comark/nuxt/plugins/breaks'
import tocPlugin from '@comark/nuxt/plugins/toc'

const props = defineProps({
  path: String,
  data: Object,
})

const { data: pageRaw } = await useAsyncData(props.path, () => {
  return queryCollection('content').path(props.path).first()
})

const page = ref(null)

watchEffect(async () => {
  if (pageRaw.value) {
    const twigRender = Twig.twig({
      data: pageRaw.value.rawbody,
    }).render(props.data)

    page.value = await parseMarkdown(twigRender, { plugins: [breaks(), tocPlugin()] })
  } else {
    page.value = null
  }
})

useSeoMeta({
  title: () => page.value?.frontmatter?.title,
  description: () => page.value?.frontmatter?.description,
})

</script>

<template>
  <UContainer>
    <UPage v-if="page">
      <UPageHeader
          :title="page.frontmatter.title"
          :description="page.frontmatter.description"
      />

      <UPageBody>
        <Markdown :value="page" />
      </UPageBody>

      <template
          v-if="page?.meta?.toc?.links?.length"
          #right
      >
        <UContentToc
            :title="page.frontmatter.title"
            :links="page?.meta?.toc?.links"
        >
          <template
              v-if="toc?.bottom"
              #bottom
          >
            <div
                class="hidden lg:block space-y-6"
                :class="{ '!mt-6': page.meta?.toc?.links?.length }"
            >
              <USeparator
                  v-if="page.meta?.toc?.links?.length"
                  type="dashed"
              />

              <UPageLinks
                  :title="toc.bottom.title"
                  :links="links"
              />
            </div>
          </template>
        </UContentToc>
      </template>
    </UPage>
  </UContainer>
</template>